import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { mergeRegister } from '@lexical/utils';
import {
  LexicalEditor,
  CAN_UNDO_COMMAND,
  COMMAND_PRIORITY_CRITICAL,
  UNDO_COMMAND,
} from 'lexical';
import { IS_APPLE } from '../../../../../utils/IsApple';
import { Icon } from '../../../../Icon';

interface PropTypes {
  activeEditor: LexicalEditor;
  isEditable: boolean;
  updateToolbar: () => void;
  classNames?: string;
}

export function UndoAction(props: PropTypes) {
  const [editor] = useLexicalComposerContext();
  const [canUndo, setCanUndo] = useState(false);

  useEffect(() => {
    return mergeRegister(
      props.activeEditor.registerCommand<boolean>(
        CAN_UNDO_COMMAND,
        (payload) => {
          setCanUndo(payload);
          return false;
        },
        COMMAND_PRIORITY_CRITICAL,
      ),
    );
  }, [props.activeEditor, editor, props.updateToolbar]);

  return (
    <button
      disabled={!canUndo || !props.isEditable}
      onClick={() => {
        props.activeEditor.dispatchCommand(UNDO_COMMAND, undefined);
      }}
      title={IS_APPLE ? 'Undo (⌘Z)' : 'Undo (Ctrl+Z)'}
      type='button'
      className={classNames(props.classNames, 'me-1')}
      aria-label='Undo'
    >
      <Icon name={'bi-arrow-counterclockwise'} />
    </button>
  );
}
